(function ($) {
    (function () {
        const SCROLL_RETRY_DELAY = 300; // 毎回の確認インターバル（ms）
        const SCROLL_RETRY_GAP = 2; // 誤差許容(px)
        const MAX_RETRY_COUNT = 5; // 最大リトライ回数

        // 現在のヘッダー高さを取得（動的対応）
        function getHeaderHeight() {
            return $('#masthead').innerHeight() || 0;
        }

        // スクロール処理（リトライ機構付き）
        function scrollToTargetWithRetry(target, attempt = 0) {
            if (!target.length || attempt > MAX_RETRY_COUNT) return;

            let headerHeight = getHeaderHeight();
            let targetPos = target.offset().top - headerHeight;

            $('html, body').stop().scrollTop(targetPos);

            // リトライチェック
            setTimeout(() => {
                let currentScroll = $(window).scrollTop();
                let newTargetPos = target.offset().top - getHeaderHeight();

                if (Math.abs(currentScroll - newTargetPos) > SCROLL_RETRY_GAP) {
                    // まだずれているなら再トライ
                    scrollToTargetWithRetry(target, attempt + 1);
                }
            }, SCROLL_RETRY_DELAY);
        }

        // ページロード時のハッシュ対応
        const urlHash = location.hash;
        if (urlHash) {
            $('html, body').stop().scrollTop(0); // 最初にリセット
            setTimeout(() => {
                const target = $(urlHash);
                scrollToTargetWithRetry(target);
            }, 100); // 初期レンダリング待ち（画像が遅延読込中でも大丈夫）
        }

        // アンカーリンククリック時（.notscrollを除外）
        $('a[href^="#"]:not(.notscroll)').on('click', function (e) {
            e.preventDefault();
            const target = $($(this).attr('href'));
            scrollToTargetWithRetry(target);
        });
    })();

})(jQuery);

// 追従サイドバー｜ページ内スクロールの際にヘッダーの高さを考慮してスクロール位置を調整

jQuery(function($) {
    var $container = $('.l-sidebar__leftbox');
    if ($container.length === 0) return; // 要素がなければ処理中断

    var $inner = $container.find('.col__inner');
    var $footer = $('.l-footer');
    var $navBlock = $('.l-single--nav.l-single--nav--c'); // 追加ブロック

    var offsetTop = $container.offset().top;
    var isFixed = false;
    var isHidden = false;
    var originalWidth = $inner.outerWidth();

    function getHeaderHeight() {
        return $('.l-header').outerHeight() || 0;
    }

    function getFooterTop() {
        return $footer.offset().top;
    }

    function getNavTop() {
        return $navBlock.length > 0 ? $navBlock.offset().top : null;
    }

    function updateSidebarPosition() {
        if ($(window).width() < 992) {
            if (isFixed || isHidden) {
                $inner.stop(true, true).css({
                    'position': '',
                    'top': '',
                    'width': '',
                    'z-index': ''
                }).show();
                isFixed = false;
                isHidden = false;
            }
            return;
        }

        var scrollTop = $(window).scrollTop();
        var headerHeight = getHeaderHeight();
        var fixedTop = headerHeight + 40;
        var innerHeight = $inner.outerHeight();
        var footerTop = getFooterTop();
        var navTop = getNavTop();
        var scrollBottom = scrollTop + fixedTop + innerHeight;

        // 固定処理
        if (scrollTop > offsetTop - fixedTop) {
            if (!isFixed) {
                isFixed = true;
                originalWidth = $inner.outerWidth();
                $inner.stop(true, true).hide().css({
                    'position': 'fixed',
                    'top': fixedTop + 'px',
                    'width': originalWidth + 'px',
                    'z-index': 100
                }).fadeIn(300);
                isHidden = false;
            }
        } else {
            if (isFixed) {
                isFixed = false;
                $inner.stop(true, true).css({
                    'position': 'static',
                    'top': '',
                    'width': '',
                    'z-index': ''
                }).show();
            }
        }

        // フッター or ナビブロックにかかったらフェードアウト
        if (isFixed) {
            var shouldHide = false;

            if (scrollBottom >= footerTop - 200) {
                shouldHide = true;
            }

            if (navTop !== null && scrollBottom >= navTop) {
                shouldHide = true;
            }

            if (shouldHide && !isHidden) {
                isHidden = true;
                $inner.stop(true, true).fadeOut(200);
            } else if (!shouldHide && isHidden) {
                isHidden = false;
                $inner.stop(true, true).fadeIn(200);
            }
        }
    }

    $(window).on('scroll resize', updateSidebarPosition);
    updateSidebarPosition(); // 初回実行
});
